import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcRuler = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			width: 24,
			height: 24
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(4 3.556)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M5.975,1.025a3.5,3.5,0,1,1-4.95,0,3.5,3.5,0,0,1,4.95,0",
				transform: "translate(4.5)"
			}), /* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M0,4.992v1a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1v-1C16,1.966,12.048,0,8,0S0,1.966,0,4.992Z",
				transform: "translate(0 10.008)"
			})]
		})
	]
});
export default SvgIcRuler;
